import { useState } from "react";
import { useSession } from "@/lib/session";
import { erreurDeLien, supabase } from "@/lib/supabase";
import { Capsule } from "@/ui/primitives";

export function Connexion() {
  const { connexion, erreur } = useSession();
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [envoi, setEnvoi] = useState(false);
  const [info, setInfo] = useState<string | null>(erreurDeLien);

  /* On ne dit jamais si l'adresse existe : ce serait dire qui travaille ici. */
  async function oubli() {
    const adresse = email.trim();
    if (!adresse) {
      setInfo("Saisissez d'abord votre adresse.");
      return;
    }
    setEnvoi(true);
    const { error } = await supabase.auth.resetPasswordForEmail(adresse, {
      redirectTo: window.location.origin,
    });
    setEnvoi(false);
    setInfo(
      !error
        ? "Si un compte porte cette adresse, un lien vient d'y être envoyé."
        : error.status === 429
          ? "Trop de demandes en peu de temps. Réessayez dans une heure."
          : error.status === 401
            ? "Le serveur refuse la clé de l'application : sa configuration est à reprendre."
            : "L'envoi a échoué. Réessayez dans un moment.",
    );
  }

  async function soumettre(e: React.FormEvent) {
    e.preventDefault();
    setEnvoi(true);
    try {
      await connexion(email, motDePasse);
    } catch {
      /* le message est porté par le contexte */
    } finally {
      setEnvoi(false);
    }
  }

  return (
    <div className="auth">
      <form className="auth-carte" onSubmit={soumettre}>
        <div className="auth-bandeau">
          <Capsule taille={22} inverse />
        </div>
        <h1 className="auth-titre">Connexion</h1>

        <div className="champ">
          <label htmlFor="email">Adresse e-mail</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="champ">
          <label htmlFor="mdp">Mot de passe</label>
          <input
            id="mdp"
            type="password"
            autoComplete="current-password"
            required
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
          />
        </div>

        {erreur ? <div className="auth-erreur">{erreur}</div> : null}
        {info ? <div className="auth-info">{info}</div> : null}

        <button className="btn btn-primary auth-entrer" type="submit" disabled={envoi}>
          {envoi ? "Connexion…" : "Entrer"}
        </button>

        <div className="auth-note">
          Catalogue, ventes et commissions.{" "}
          <button type="button" className="auth-lien" disabled={envoi} onClick={() => void oubli()}>
            Mot de passe oublié ?
          </button>
        </div>
      </form>
    </div>
  );
}
